import React from 'react';

const VARIANTS = {
  default: 'bg-gray-50 dark:bg-[#0f1419]',
  alt: 'bg-white dark:bg-[#0a0e1a]',
  muted: 'bg-gray-50 dark:bg-[#0a0e1a]',
};

export const SectionShell = ({ id, variant = 'default', className = '', children }) => (
  <section
    id={id}
    className={`scroll-mt-20 py-14 sm:py-18 md:py-20 lg:py-24 transition-colors duration-300 ${VARIANTS[variant] ?? VARIANTS.default} ${className}`}
  >
    <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{children}</div>
  </section>
);

export const SectionInner = ({ children, className = '' }) => (
  <div className={`mx-auto max-w-6xl ${className}`}>{children}</div>
);

export const SectionHeader = ({
  title,
  highlight,
  highlightGlue = ' ',
  description,
  className = '',
}) => (
  <div className={`mx-auto mb-10 max-w-3xl text-center sm:mb-12 lg:mb-16 ${className}`}>
    <h2 className="mb-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl lg:text-5xl">
      {title}
      {highlight ? (
        <>
          {highlightGlue}
          <span className="text-emerald-400">{highlight}</span>
        </>
      ) : null}
    </h2>
    <div className="mx-auto mb-4 h-1 w-20 bg-gradient-to-r from-emerald-400 to-teal-400 sm:mb-6 sm:w-24" />
    {description ? (
      <p className="px-1 text-base leading-relaxed text-gray-600 dark:text-gray-400 sm:text-lg">
        {description}
      </p>
    ) : null}
  </div>
);

export const SectionLoading = ({ id, variant = 'default' }) => (
  <SectionShell id={id} variant={variant}>
    <SectionInner>
      <div className="py-12 text-center sm:py-16">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-b-2 border-emerald-500 sm:h-12 sm:w-12" />
        <p className="mt-4 text-sm text-gray-600 dark:text-gray-400 sm:text-base">Chargement...</p>
      </div>
    </SectionInner>
  </SectionShell>
);

export const SectionError = ({ id, error, variant = 'default' }) => (
  <SectionShell id={id} variant={variant}>
    <SectionInner>
      <p className="py-8 text-center text-red-500">Erreur: {error}</p>
    </SectionInner>
  </SectionShell>
);
